import { createContext, useContext, ReactNode } from "react";
import { Show } from "shared/components";
import { cx } from "shared/utils";

const TimeLineLeftSlotWidthContext = createContext<string | undefined>(
  undefined
);

export const TimeLine = (props: {
  wrapperClassName?: string;
  leftSlotWidth?: string;
  children: ReactNode;
}) => {
  const { leftSlotWidth, wrapperClassName } = props;
  const hasLeftSlotColumn = Boolean(leftSlotWidth);

  return (
    <TimeLineLeftSlotWidthContext.Provider value={leftSlotWidth}>
      <div
        className={cx(
          "flex",
          !hasLeftSlotColumn && "border-l border-dashed",
          wrapperClassName ?? "ml-2 border-alpha-100 pl-2 pt-1"
        )}
      >
        {hasLeftSlotColumn ? (
          <>
            <div
              className="shrink-0"
              style={{ width: leftSlotWidth }}
              aria-hidden
            />
            <div className="min-w-0 flex-1 border-l border-dashed border-alpha-100 pt-1">
              <ul className="list-none">{props.children}</ul>
            </div>
          </>
        ) : (
          <ul className="list-none flex-1">{props.children}</ul>
        )}
      </div>
    </TimeLineLeftSlotWidthContext.Provider>
  );
};

export const TimeLineItem = (props: {
  onClick?: () => void;
  leftSlot?: ReactNode;
  bullet?: ReactNode;
  children: ReactNode;
  isLast?: boolean;
  wrapperClassName?: string;
  childrenClassName?: string;
}) => {
  const leftSlotWidth = useContext(TimeLineLeftSlotWidthContext);
  const hasLeftSlot = props.leftSlot != null && leftSlotWidth != null;

  return (
    <li
      className={cx("flex", props.wrapperClassName)}
      style={hasLeftSlot ? { marginLeft: `-${leftSlotWidth}` } : undefined}
      onClick={props.onClick}
    >
      <Show if={!!props.leftSlot}>
        <div style={{ flexShrink: 0, width: leftSlotWidth }}>
          {props.leftSlot}
        </div>
      </Show>
      {props.bullet != null ? (
        props.bullet
      ) : (
        <div className="h-[9px] w-[9px] translate-x-[-13px] rounded-full bg-[#E8E8E9]" />
      )}
      <div className={props.childrenClassName}> {props.children}</div>
    </li>
  );
};
